module.exports = __webpack_public_path__ + "media/Access_Registration_Info.4c8fdea7.mp4";